module.exports = __webpack_public_path__ + "static/media/certificate category.39c53d65.svg";